<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="baseCustomerPropertyValueMapping.pkid > 0 ? '编辑':'新建'"
      class="customer-edit"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="baseCustomerPropertyValueMapping"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="客户特性名">
        <el-input v-model="baseCustomerPropertyValueMapping.customerProperyName" readonly/>
      </el-form-item>
      <el-form-item/>
      <el-form-item label="客户特性值">
        <el-input v-model="baseCustomerPropertyValueMapping.customerProperyValue" type="textarea" readonly/>
      </el-form-item>
      <el-form-item label="SAP特性值">
        <el-input v-model="baseCustomerPropertyValueMapping.sapPropertyValue" type="textarea" readonly/>
      </el-form-item>
      <el-form-item label="是否导入SAP">
        <el-switch
            v-model="baseCustomerPropertyValueMapping.sapRequire"
            style="display: block"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            :active-value="true"
            inactive-text="否"
            :inactive-value="false"/>
      </el-form-item>
      <el-form-item label="数据类型" prop="dataType">
        <el-select v-model.trim="baseCustomerPropertyValueMapping.dataType" clearable placeholder="请选择">
          <el-option
              v-for="item in dataTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="别名">
        <el-input v-model="baseCustomerPropertyValueMapping.propertyNickName" type="textarea" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constant from "@/util/constant";

  export default {
    name: "SAPBaseCustomerMaterialMappingEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        dataTypes:constant.toSelect(constant.dataType),
        contentLoading: false,
        submitLoading: false,
        baseCustomerPropertyValueMapping: {
          pkid: "",
          customerProperyName: "",
          customerProperyValue: "",
          sapPropertyValue: "",
          dataType: "",
          propertyNickName: "",
          sapRequire: 10,
        },
        ruleValidate: {
          dataType: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.baseCustomerPropertyValueMapping.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `baseCustomerPropertyValueMappings/${this.baseCustomerPropertyValueMapping.pkid}`)
          .then(resp => {
            console.log(resp);
            this.baseCustomerPropertyValueMapping = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .saveById("basic", "baseCustomerPropertyValueMappings", this.baseCustomerPropertyValueMapping,this.baseCustomerPropertyValueMapping.pkid)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
